import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import DDadosItem from "@common/components/ddados/ddados.item";
import alvaraSelector from "../store/alvara.selectors";
import alvaraActions from "../store/alvara.actions";
import { ddadosVisualizarAlvara as DDados } from "../visualizarAlvara.ddados";
import Form from "@common/externos/components/validation/form.validation";
import { Row, Col } from "react-bootstrap";
import autoBind from "react-autobind";
import Panel from "@common/externos/components/panel/panel.component";
import Button from "@material-ui/core/Button";
import sessionStorageUtils from "@common/helpers/sessionStorage.utils";
import Address from "@common/components/address/components/address.component";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      blockDoubleClick: true
    }
  }

  componentDidMount() {
    const alvara = sessionStorageUtils.getItem('alvara');
    this.props.alvaraActions.getAlvara(alvara);
  }

  componentWillUnmount(){
    window.sessionStorage.removeItem('alvara');
  }

  get initialValues() {
    return {};
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: "obrasParticulares.validarAlvara" });
  }

  onPrintReport() {
    const { alvara } = this.props.alvaraSelector;

    const data = {
      NumeroAlvara: alvara.Numero,
      EmissaoAlvara: alvara.DataEmissaoAlvara,
      AnoProjeto: alvara.AnoProjeto,
      NumeroProjeto: alvara.NumeroProjeto
    }

    this.props.alvaraActions.imprimirAlvara(data);
  }

  render() {
    const { Campos, Titulo } = DDados;
    const { form, disableAll } = this.props;
    const { alvara } = this.props.alvaraSelector;
    const prefix = "V";

    return (
        <Form boxForm initialValues={this.initialValues} title={Titulo} onCancel={this.onCancel} onPrintReport={this.onPrintReport}>
          {form => (
      <Fragment>
        <Row>
          <Col lg={"3"}>
            <DDadosItem name="Protocolo" {...Campos.Protocolo}  state={alvara}/>
          </Col>
          <Col lg={"3"}>
            <DDadosItem name="Processo" {...Campos.Processo}  state={alvara}/>
          </Col>
          <Col lg={"3"}>
            <DDadosItem name="Projeto" {...Campos.Projeto}  state={alvara}/>
          </Col>
          <Col lg={"3"}>
            <DDadosItem name="DataInicio" {...Campos.DataInicio}  state={alvara}/>
          </Col>
        </Row>
        <Row>
          <Col lg={"12"}>
            <DDadosItem name="Solicitante" {...Campos.Solicitante}  state={alvara}/>
          </Col>
        </Row>
        <Row>
          <Col lg={"8"}>
            <DDadosItem name="ResponsavelProjeto" {...Campos.ResponsavelProjeto}  state={alvara}/>
          </Col>
          <Col lg={"4"}>
            <DDadosItem name="ARTResponsavelProjeto" {...Campos.ARTResponsavelProjeto}  state={alvara}/>
          </Col>
        </Row>
        <Row>
          <Col lg={"8"}>
            <DDadosItem name="ResponsavelExecucao" {...Campos.ResponsavelExecucao}  state={alvara}/>
          </Col>
          <Col lg={"4"}>
            <DDadosItem name="ARTResponsavelExecucao" {...Campos.ARTResponsavelExecucao}  state={alvara}/>
          </Col>
        </Row>
        <Row>
          <Col lg={"4"}>
            <DDadosItem name="DataVencimento" {...Campos.DataVencimento}  state={alvara}/>
          </Col>
          <Col lg={"4"}>
            <DDadosItem name="Numero" {...Campos.Numero}  state={alvara}/>
          </Col>
          <Col lg={"4"}>
            <DDadosItem name="Situacao" {...Campos.Situacao}  state={alvara}/>
          </Col>
        </Row>
        <Row>
          <Col lg={"12"}>
            <DDadosItem name="Proprietario" {...Campos.Proprietario}  state={alvara}/>
          </Col>
        </Row>


        <Row>
          <Col lg={"12"}>
            <Address name="Endereco" state={alvara.Endereco} prefix={prefix}/>
          </Col>
        </Row>



        </Fragment>
        )}
        </Form>
    );
  }
}

export default connect({
  selectors: {
    alvaraSelector
  },
  actions: {
    alvaraActions
  }
})(Container);
